module.exports = "/wwwroot/img/waste_search_result_page.png?ver=84091c7f";